import { GET_DEVICE_ID } from 'redux/consts/settings';

export function getDeviceId() {
  return {
    type: GET_DEVICE_ID,
  };
}
